export default __webpack_public_path__ + "static/media/metaworks-logo.0f8ece5e.png";